import { ArrowLeft, ArrowRight } from "lucide-react";
import React, { useRef } from "react";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

const WebStoryDetailPage = ({ article, onBack, onPrev, onNext }) => {
  const swiperRef = useRef(null);

  return (
    <>
      <div>
        <div className="px-4 bg-white py-2 flex flex-wrap items-center gap-3 sm:flex-nowrap justify-between">
          {/* LEFT: Back */}
          <button
            onClick={onBack}
            className="order-1 sm:order-none group inline-flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-gray-900"
          >
            <ArrowLeft
              size={16}
              className="transition-transform group-hover:-translate-x-1"
            />
            Back to list
          </button>

          {/* CENTER: Prev / Next */}
          <div className="order-3 w-full sm:order-none sm:w-auto flex justify-center gap-3">
            {/* PREV */}
            <button
              onClick={onPrev}
              className="group flex items-center gap-2 px-4 py-2 rounded-xl
        border border-gray-200 bg-white
        hover:border-orange-400 hover:bg-orange-50
        disabled:opacity-40"
            >
              <ArrowLeft
                size={16}
                className="transition-transform group-hover:-translate-x-1"
              />
              <span className="text-sm font-semibold">Prev</span>
            </button>

            {/* NEXT */}
            <button
              onClick={onNext}
              className="group flex items-center gap-2 px-4 py-2 rounded-xl
        bg-orange-500 text-white
        hover:bg-orange-600
        disabled:opacity-40"
            >
              <span className="text-sm font-semibold">Next</span>
              <ArrowRight
                size={16}
                className="transition-transform group-hover:translate-x-1"
              />
            </button>
          </div>

          {/* RIGHT: Visit */}
          {article?.post_url && (
            <a
              href={article.post_url}
              target="_blank"
              rel="noopener noreferrer"
              className="
        order-2 sm:order-none
        inline-flex items-center gap-1.5
        px-3 py-1.5 rounded-md
        bg-gray-100 text-gray-700
        font-medium text-xs sm:text-sm
        hover:bg-gray-200 transition-colors
      "
            >
              Visit on Site <span>↗</span>
            </a>
          )}
        </div>
        <div className="w-full max-w-3xl mx-auto mt-4 relative">
          <Swiper
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            loop={article?.images?.length > 1}
            spaceBetween={20}
            slidesPerView={1}
            grabCursor={true}
            className="rounded-2xl overflow-hidden shadow-lg"
          >
            {article?.images?.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="w-full h-[80vh] bg-white flex items-center justify-center">
                  <img
                    src={item}
                    alt={`slide-${index}`}
                    className="w-full h-full object-contain"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <button
            onClick={() => swiperRef.current?.slidePrev()}
            className="absolute left-3 top-1/2 -translate-y-1/2 z-10
        w-10 h-10 flex items-center justify-center
        rounded-full bg-white/80 backdrop-blur-md
        shadow-md hover:bg-orange-500 hover:text-white
        transition-all duration-300"
          >
            <ArrowLeft size={18} />
          </button>

          {/* 🔥 NEXT BUTTON */}
          <button
            onClick={() => swiperRef.current?.slideNext()}
            className="absolute right-3 top-1/2 -translate-y-1/2 z-10
        w-10 h-10 flex items-center justify-center
        rounded-full bg-white/80 backdrop-blur-md
        shadow-md hover:bg-orange-500 hover:text-white
        transition-all duration-300"
          >
            <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </>
  );
};

export default WebStoryDetailPage;
